//GeneratorFlag:[NoChange]
import PersonMilitary from './person-military';

export default {PersonMilitary}
export{PersonMilitary}